import { Guid } from 'guid-typescript';
import { SiaI18nService } from './i18n.service';

export function notify(
  message: string,
  duration: number,
  type?: 'success' | 'error' | 'warning' | 'info',
  icon?: string,
  animation?: string,
) {
  const i18nService = SiaI18nService.instance;
  const translatedMessage = i18nService?.translate(message) ?? message;
  var container: HTMLElement | null = document.querySelector(
    '#sia-notification-container',
  );
  if (!container) {
    container = document.createElement('div');
    container.id = 'sia-notification-container';
    container.style.cssText = `position: fixed;
        width:min(95%, 1000px);
        opacity:1;
        z-index:1000;
        left: 50%;
        transform: translate(-50%, 0);
        display: flex;
        flex-flow: column nowrap;
        color: #fff;
        pointer-events: none;`;
    document.body.appendChild(container);
  }
  container.style.bottom = '0px';

  if (animation === 'pulsate') {
    container.style.top = '2rem';
    container.style.bottom = 'auto';
    container.style.alignItems = 'center';
  } else {
    container.style.top = 'auto';
    container.style.bottom = '0px';
    container.style.alignItems = 'stretch';
  }

  var guid = Guid.create().toString();
  var notificationContainer = document.createElement('div');
  notificationContainer.id = guid;
  var containerStyle = `
    width: ${animation === 'pulsate' ? 'fit-content' : 'calc(100%)'};
    opacity:1;
    z-index:100;
    margin: 5px 0;
    border-radius: 8px;
    display: flex;
    justify-content: start;
    padding: 8px 16px;        
    align-items: center;
    flex-flow: row nowrap;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;`;

  if (animation === 'pulsate') {
    notificationContainer.classList.add('animate-pulse');
  }

  notificationContainer.className += setNotificationColorClasses(type);
  notificationContainer.style.cssText = containerStyle;
  if (icon) {
    var iconContainer = document.createElement('div');
    iconContainer.className = 'material-symbols-outlined';
    iconContainer.style.cssText = `margin-right:10px; font-size: 30px;`;
    iconContainer.innerText = icon;
    notificationContainer.appendChild(iconContainer);
  } else {
    var iconContainer = document.createElement('div');
    iconContainer.className = 'material-symbols-outlined';
    iconContainer.style.cssText = `margin-right:10px; font-size: 30px;`;
    //for every type of notification we have a different icon
    switch (type) {
      case 'success':
        iconContainer.innerText = 'check_circle';
        break;
      case 'error':
        iconContainer.innerText = 'error';
        break;
      case 'warning':
        iconContainer.innerText = 'warning';
        break;
      case 'info':
        iconContainer.innerText = 'info';
        break;
      default:
        iconContainer.innerText = 'info';
        break;
    }
    notificationContainer.appendChild(iconContainer);
  }
  var messageContainer = document.createElement('div');
  messageContainer.innerText = translatedMessage;
  messageContainer.style.cssText = `font-size: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;`;
  notificationContainer.appendChild(messageContainer);
  container.appendChild(notificationContainer);
  setTimeout(() => {
    if (container) {
      container.removeChild(notificationContainer);
    }
  }, duration);
}

export function setNotificationColorClasses(
  type?: 'success' | 'error' | 'warning' | 'info',
): string {
  let classes = ' ';
  switch (type) {
    case 'success':
      classes += 'fg-success bg-success';
      break;
    case 'error':
      classes += 'fg-error bg-error';
      break;
    case 'warning':
      classes += 'fg-warning bg-warning';
      break;
    case 'info':
      classes += 'fg-info bg-info';
      break;
    default:
      classes += '';
      break;
  }
  return classes;
}
